import { render } from "./End.vue?vue&type=template&id=71e4fc84&ts=true"
import script from "./End.vue?vue&type=script&lang=ts"
export * from "./End.vue?vue&type=script&lang=ts"

import "./End.vue?vue&type=style&index=0&id=71e4fc84&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__